import moment from "moment";
import { findUnixExpiryFromPeriods } from "./timeUtils";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";

export const generateEndTimes = () => {
	let localStartTime = new Date(); // Now
	let localEndTime = new Date();
	localEndTime.setHours(23, 55, 0, 0); // End of the day

	const localisedMaxEndTime = useClassroomSessionStore.getState().getLocalisedMaxEndTime();
	if (localisedMaxEndTime) {
		localStartTime = localisedMaxEndTime.localStartTime;
		localEndTime = localisedMaxEndTime.localEndTime;
	}

	// Set localStartTime to align with the next 5 minute interval
	localStartTime = moment(localStartTime)
		.add(5 - (localStartTime.getMinutes() % 5), "m")
		.toDate();

	// Set localEndTime to align with the previous 5 minute interval
	localEndTime = moment(localEndTime)
		.add(0 - (localEndTime.getMinutes() % 5), "m")
		.toDate();

	// Get total minutes
	const totalMinutes = (localEndTime - localStartTime) / 60000;
	const totalMinuteBlocks = totalMinutes / 5;

	const endTimes = [];
	for (let minuteBlock = 0; minuteBlock <= totalMinuteBlocks; minuteBlock++) {
		const minuteTime = moment(localStartTime)
			.add(5 * minuteBlock, "m")
			.toDate(); // Add 5 minutes
		const endTimeInt = minuteTime.getHours() * 100 + minuteTime.getMinutes();
		let endTimeStr = moment(minuteTime, "HHmm").format("LT");
		if (endTimeStr[1] === ":") {
			endTimeStr = "0" + endTimeStr;
		}

		/** Integer endTime is purposely pushed into the endTimes list and will only be converted to
		 * "seconds until class expires" when teacher presses the save button. This is to handle the
		 * case wherein the dropdown is open for more than a minute and teacher selects end time of 4:00 PM
		 * but the classroom shows to end at 4:01 PM
		 */
		endTimes.push({ value: endTimeInt, text: endTimeStr });
	}
	return endTimes;
};

// Returns a tuple of [isActive, expiry, scheduledClass]
// expiry is null if isActive is false
export const classroomActiveInfo = (classroom) => {
	const currentTime = new Date().getTime() / 1000;
	if (classroom.is_monitoring_class) {
		if (classroom.monitoring && classroom.monitoring.end_time > currentTime) {
			return [true, classroom.monitoring.end_time, false];
		}
		return [false, 0, false];
	} else {
		if (classroom.zoom.schedule.active_until > currentTime) {
			return [true, classroom.zoom.schedule.active_until, false];
		}
		const expiryUnix = findUnixExpiryFromPeriods(classroom.zoom.schedule.periods);
		return [expiryUnix !== null, expiryUnix, expiryUnix !== null];
	}
};

/**
 * This is a function that returns tuple object containing parsed classroom information.
 * @param {classroom inforamtin to be parse and return the details} classroom
 * @returns {tuple with [isActive, Expiry, isScheduled] information about the classroom passed in parameter}
 */
export const classroomActiveInfoV2 = (classroom) => {
	const currentTime = new Date().getTime() / 1000;
	const sessionEndTime = classroom.session?.sessionEndTime;
	if (classroom.session?.isMonitoring) {
		if (sessionEndTime && sessionEndTime > currentTime) {
			return [true, sessionEndTime, false];
		}
		return [false, 0, false];
	} else {
		if (sessionEndTime && sessionEndTime > currentTime) {
			return [true, sessionEndTime, false];
		}
		const expiryUnix = findUnixExpiryFromPeriods(classroom?.schedule?.periods);
		return [expiryUnix !== null, expiryUnix, expiryUnix !== null];
	}
};
